import { Provider } from '@angular/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const translateProviders: Provider[] = [
  provideTranslateService({
    fallbackLang: 'en',
    loader: provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json',
      useHttpBackend: true,
      failOnError: true,
    }),
  }),
];
